import { schema } from "normalizr";
import { PageLayoutSchema } from "./page-layout";

export const PageLayoutsSchema = new schema.Array(PageLayoutSchema);
